import { useLocation } from '@eastcoal/router/exports/react-router'

import { useParsedSearch } from '../useParsedSearch'

export const useUrlParams = () => {
  const { search } = useLocation()
  return useParsedSearch(search)
}
